import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    parameters: {} //保存页面传参
  },
  getters: {
    parameters: state => {
      //获取方法
      return state.parameters;
    }
  },
  mutations: {
    setParameters: (state, parametersData) => {
      //页面参数传递格式{key:'key',value:'value'}
      if (parametersData) {
        //试了好久state.parameters[key]=value这样会报错只能先取出来添加属性再赋值
        let parameters = state.parameters;
        parameters[parametersData.key] = parametersData.value;
        state.parameters = parameters;
      }
    }
  },
  actions: {},
  modules: {}
});



// WEBPACK FOOTER //
// ./src/store/index.js